module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cf40829810bd4179a0bb018aec432b0b.gif";